import {
  Badge,
  Field,
  FieldLabel,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@e2n/ui';
import { useTranslation } from 'react-i18next';
import type { Vertrag } from '../hooks/useVertragAuswahl';

const VERTRAG_PRAEFIX = 'W-';
const KUNDE_PRAEFIX = 'K-';
const VERTRAG_FELD = 'vertrag';

type VertragAuswahlProps = {
  vertraege: Vertrag[];
  vertrag?: Vertrag;
  laedt: boolean;
  onWaehle: (vertragsnummer: string) => void;
};

export function VertragAuswahl({
  vertraege,
  vertrag,
  laedt,
  onWaehle,
}: VertragAuswahlProps) {
  const { t } = useTranslation();

  return (
    <Field>
      <FieldLabel htmlFor={VERTRAG_FELD}>
        {t('domain.e2nApi.aktivierung.dialog.vertrag')}
      </FieldLabel>
      <Select
        value={vertrag?.vertragsnummer ?? ''}
        onValueChange={onWaehle}
        disabled={laedt}>
        <SelectTrigger id={VERTRAG_FELD} className="w-full">
          <SelectValue
            placeholder={t(
              'domain.e2nApi.aktivierung.dialog.vertragAuswaehlen',
            )}
          />
        </SelectTrigger>
        <SelectContent>
          {vertraege.map((option) => (
            <SelectItem
              key={option.vertragsnummer}
              value={option.vertragsnummer}>
              <VertragOption vertrag={option} />
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </Field>
  );
}

function VertragOption({ vertrag }: { vertrag: Vertrag }) {
  return (
    <span className="flex min-w-0 items-center gap-2">
      <span className="font-bold">
        {VERTRAG_PRAEFIX}
        {vertrag.vertragsnummer}
      </span>
      <Badge variant="secondary" className="font-semibold text-neutrals-800">
        {KUNDE_PRAEFIX}
        {vertrag.kundennummer}
      </Badge>
      <span className="truncate">{vertrag.unternehmensname}</span>
    </span>
  );
}
